import StockView from "./StockView";

export {StockView}
export default StockView
